export interface Instalment {
  instalment_id?: number;
  invoice_no?: number | null;
  project_id?: number;
  instalment_no?: string;
  instalment_amount?: number;
  invoice_date?: string;
  payment_date?: string;
  status?: "Paid" | "Unpaid" | "Draft";
  invoice?: string | null;
  address?: string;
  job_number?: string;
}

// to single object maping
export const mapInstalment = (data: any): Instalment => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: Instalment = {
    instalment_id: data.instalment_id,
    invoice_no: data.invoice_no,
    project_id: data.project_id,
    instalment_no: data.instalment_no,
    instalment_amount: data.instalment_amount,
    invoice_date: data.invoice_date,
    payment_date: data.payment_date,
    status: data.status,
    invoice: data.invoice,
    address: data.address,
    job_number: data.job_number,
  };
  return res;
};

// maping list objects
export const mapInstalments = (data: any[]): Instalment[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapInstalment);
};

export interface Payment {
  instalments?: Instalment[];
  next_invoice_no?: string;
}

// to single object maping
export const mapPayment = (data: any): Payment => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: Payment = {
    instalments: mapInstalments(data.data),
    next_invoice_no: data.next_invoice_no,
  };
  return res;
};
